import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import "./Login.css"; // folosim același CSS ca la Login

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const club_id = searchParams.get("club_id");
  const token = searchParams.get("token");

  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(
        "https://www.fro.ro/api/clubs/reset-password.php", // 👈 exact cum aveai
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ club_id, token, new_password: newPassword }),
        }
      );

      const data = await res.json();
      setMessage(data.message);

      if (data.success) {
        setTimeout(() => navigate("/login"), 2000);
      }
    } catch {
      setMessage("Eroare la conexiune.");
    }
  };

  if (!club_id || !token) {
    return (
      <div className="login-bg">
        <div className="login-card">
          <h2 className="login-title">Link invalid sau incomplet</h2>
          <p className="login-message">Verifică emailul de resetare.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="login-bg">
      <div className="login-card">
        <div className="login-logo">Federația Română de Orientare</div>
        <h2 className="login-title">Resetare parolă club</h2>
        <form onSubmit={handleSubmit} className="login-form">
          <label className="login-label">Parola nouă</label>
          <input
            type="password"
            className="login-input"
            placeholder="Introduceți parola nouă"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
          <button type="submit" className="login-btn" style={{ marginTop: 20 }}>
            Resetează parola
          </button>
        </form>
        {message && <p className="login-message">{message}</p>}
      </div>
    </div>
  );
}
